import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback } from "react";
import cn from "classnames";
import ChevronLarge from "@icons/ChevronLarge";
import useIsRTL from "@hooks/useIsRTL";
const SwiperButtonRounded = ({ isNext, className, swiper, iconClassName }) => {
    const { isRtl } = useIsRTL();
    const nextSlide = useCallback(() => {
        if (!swiper) {
            return;
        }
        return isRtl ? swiper.slidePrev() : swiper.slideNext();
    }, [swiper, isRtl]);
    const prevSlide = useCallback(() => {
        if (!swiper) {
            return;
        }
        return !isRtl ? swiper.slidePrev() : swiper.slideNext();
    }, [swiper, isRtl]);
    return (_jsx("button", { className: cn("swiper-btn__rounded", isNext && "swiper-btn__rounded--next", className), onClick: () => {
            isNext ? nextSlide() : prevSlide();
        }, children: _jsx(ChevronLarge, { className: cn("swiper-btn__rounded-icon", iconClassName) }) }));
};
export default SwiperButtonRounded;
